import { getColorVariantFromBackground } from '@klv/shared/utils/functions';
import type { ICards } from './types';
import * as s from './styles';

const Cards = ({
  cards, headline = '', subhead = '', variant = 'light', ...props
}: ICards) => (
  <s.StyledCards $variant={variant} {...props}>
    <s.StyledGrid>
      <s.HeadlineGroup>
        {headline && <s.StyledHeadline colorVariant={getColorVariantFromBackground(variant)} variant="h3">{headline}</s.StyledHeadline>}
        <s.StyledSubhead colorVariant={getColorVariantFromBackground(variant)} variant="paragraph2">{subhead}</s.StyledSubhead>
      </s.HeadlineGroup>
      <s.CardGroup>
        {(cards.length > 0) && cards.map((singleCard) => {
          const nestedCard = singleCard.card;

          return (
            <s.StyledCard
              key={JSON.stringify(nestedCard)}
              bodyCopy={nestedCard.bodyCopy}
              buttons={nestedCard?.buttons}
              icon={nestedCard?.icon}
              variant={variant}
              title={nestedCard.title}
            />
          );
        })}
      </s.CardGroup>
    </s.StyledGrid>
  </s.StyledCards>
);

export default Cards;
